import React, { CSSProperties } from "react"
import { TextField } from "material-ui"
import * as utils from "../../helpers/utils"
interface IProps {
    readonly?: boolean
    name?: string
    label: string
    value: string
    error?: string
    style?: CSSProperties
    handleChange?(value: string): void
    handleOnBlur?(): void
    underlineDisabledStyle?: CSSProperties
}

const DoubleField: React.SFC<IProps> = (props: IProps) => {
    return (
        <TextField
            data-intercom-target={`Entry-${props.label}`}
            name={props.name}
            floatingLabelText={props.label}
            value={props.value === null ? "" : props.value}
            onChange={e =>
                props.handleChange &&
                (e.target.value === "" || utils.validateDouble(e.target.value)) &&
                props.handleChange(e.target.value)
            }
            onBlur={() => props.handleOnBlur && props.handleOnBlur()}
            style={props.style ? props.style : {}}
            errorText={props.error}
            errorStyle={{ position: "absolute", top: 70 }}
            disabled={props.readonly}
            underlineDisabledStyle={props.underlineDisabledStyle ? props.underlineDisabledStyle : {}}
        />
    )
}

export default DoubleField
